import React from 'react';

import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { ModalTitle } from './modal-title';
import { StyledMarkdown } from './typeface';
// import styles from "../styles/components/info-modal.module.scss"

interface InfoModalProps {
  onClose: () => void
  title: string
  content: string | React.ReactNode
  maxWidth?: "md" | "lg" | "sm" | "xs" | "xl"
  open: boolean
}

export const InfoModal = ({
  // currentFeature,
  onClose,
  title,
  content,
  maxWidth = "md",
  open,
}: InfoModalProps) => {
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
    >
      <ModalTitle onClose={onClose}>{title}</ModalTitle>
      <DialogContent>
        {typeof content === "string" ?
          <StyledMarkdown>
            {content}
          </StyledMarkdown>
          :
          <>{content}</>
        }
      </DialogContent>
      <DialogActions sx={{justifyContent: 'flex-end', pb: 3, px: 3}}>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
